<template>
  <div id="landing">
    <div id="landing-video" class="relative">
      <iframe id="background-video" :src="`https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1`" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>

    <div class="top-left mt2 ml2 sm-mt3 sm-ml3">
      <h1>Katie Paterson: First There is a Mountain</h1>
      <ul class="list-reset flex-auto m0">
        <li class="inline-block"><a href="#" class="black" v-scroll-to="{ el: '#content', duration: 200 }">Locations,</a></li>
        <li class="inline-block"><router-link :to="{ name: 'About' }">About,</router-link></li>
        <li class="inline-block"><a href="/map" class="black" target="_blank">Map,</a></li>
        <li class="inline-block"><router-link :to="{ name: 'Gallery' }">Gallery,</router-link></li>
        <li class="inline-block"><router-link :to="{ name: 'Visitor Information' }">Visitor Information,</router-link></li>
        <li class="inline-block"><a href="https://prismic-io.s3.amazonaws.com/ftiam/e55cf3e4-8d0b-4b9c-8428-efe3202ca965_FTIAM-Anthology-v2-spread-lines.pdf">Anthology</a></li>
      </ul>
    </div>
    <div class="top-right mt2 mr2 sm-mt3 sm-mr3 right-align" style="max-width: 45vw" v-if="dataLoaded && nextEvent">
      <router-link class="black block" :to="{ name: 'Location', params: { slug: nextEvent.slugs[0] }}">
        <span v-html="nextEventSummary"></span>
      </router-link>
    </div>

    <div class="bottom-right mb2 mr2 sm-mb3 sm-mr3 pointer absolute" style="position: absolute">
<!--       <span @click="subtitles = !subtitles" class="pointer">
        <span v-if="subtitles">No Subtitles</span>
        <span v-else>Subtitles</span>
      </span> -->

      <span @click="toggleMute()" class="pointer ml2">
        <span v-if="muted">Unmute Video</span>
        <span v-else>Mute Video</span>
      </span>
    </div>

    <div id="content" class="px1 sm-px3 pt0">
      <main-menu :showSub='true' class='sticky'></main-menu>

      <div v-if="dataLoaded">
        <location-preview
          v-for="event in events"
          :data="event"
          :weather="weatherForLocation(event)"
          :key="event.id"></location-preview>

        <a href="#" class="mt-big block center p3 border mx-auto" v-scroll-to="{
          el: 'body',
          duration: 200
        }">Back to Top</a>
      </div>

      <div class="mt3">
        <a href="https://www.instagram.com/firstthereisamountain/" target="_blank">Instagram,</a>
        <a href="https://www.facebook.com/pages/category/Art/FirstthereisamountainUK/about/" target="_blank">Facebook</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import PrismicDOM from 'prismic-dom'
import mainMenu from '@/components/MainMenu'
import locationPreview from '@/components/LocationPreview'
import Player from '@vimeo/player'

export default {

  name: 'Landing',

  data () {
    return {
      subtitles: false,
      muted: true,
      loading: true,
      content: false,
      player: null
    }
  },

  components: {
    locationPreview,
    mainMenu
  },

  computed: {
    ...mapState([
      'events',
      'weather'
    ]),
    ...mapGetters([
      'nextEvent'
    ]),
    videoId() {
      if (this.subtitles) {
        return '316766748'
      } else {
        return '320766749'
      }
    },
    dataLoaded() {
      return this.events && this.weather
    },
    title () {
      return PrismicDOM.RichText.asHtml(this.content.data.title)
    },
    subTitle () {
      return PrismicDOM.RichText.asHtml(this.content.data.subtitle)
    },
    description () {
      return PrismicDOM.RichText.asHtml(this.content.data.content)
    },
    locations () {
      return PrismicDOM.RichText.asHtml(this.content.data.locations)
    },
    contact () {
      return PrismicDOM.RichText.asHtml(this.content.data.contact)
    },
    nextEventSummary () {
      if (this.weather.length) {
        let weather = this.weather.find(x => x.id === this.nextEvent.id).weather
        return `<span class="xs-hide sm-hide"><span class="sm-hide md-hide">Next: </span><span>${this.processText(this.nextEvent.data.title)}</span><span class="sm-hide md-hide"> (${this.processText(this.nextEvent.data.beach_title)})</span> <span>${Math.round(weather.currently.temperature)}°&nbsp;${weather.currently.summary.replace('Dangerously', '').replace(' ', '&nbsp;')}</span></span>`
      } else {
        return `<span class="xs-hide sm-hide"><span class="sm-hide md-hide">Next: </span><span>${this.processText(this.nextEvent.data.title)}</span><span class="sm-hide md-hide"> (${this.processText(this.nextEvent.data.beach_title)})</span></span>`
      }
    }
  },

  methods: {
    // processDate (el) {
    //   return Dayjs(PrismicDOM.Date(el)).format('MMMM D')
    // },
    processText (el) {
      return PrismicDOM.RichText.asText(el)
    },
    weatherForLocation (location) {
      if (this.weather.length) {
        return this.weather.find(x => x.id === location.id).weather.currently
      } else {
        return ''
      }
    },
    toggleMute() {
      this.muted = !this.muted

      if (this.muted) {
        this.player.setVolume(0)
      } else {
        this.player.setVolume(1)
      }
    }
  },

  mounted () {
    if (this.$route.params.loc === 'locations') {
      VueScrollTo.scrollTo('#navigation', 0, {
        offset: 10
      })
    }
    this.player = new Player('background-video')
  },

  // watch: {
  //   '$route': function (to, from, next) {
  //     console.log(from)
  //     next()
  //   }
  // }
}
</script>

<style lang="css">
  @-webkit-keyframes load_blur {
    0% { opacity: 0; -webkit-filter: blur(5px);}
    100% { opacity: 1; -webkit-filter: blur(0px);}
  }
  #landing-video {
    -webkit-animation: load_blur 2s;
    background-image: url('../assets/sand.jpg');
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100vh;
    pointer-events: none;
    overflow-x: hidden;

    iframe {
      width: 100vw;
      height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
      min-height: 100.2vh;
      min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50.1%);
    }
  }
</style>
